module.exports = __webpack_public_path__ + "bell.png?3638a87d9bcd3f0377e966ca00b0ae96";